'use es6';

import FireAlarmApp from './FireAlarmApp';
const hubspot = window.hubspot = window.hubspot || {};
if (!hubspot.fireAlarm) {
  hubspot.fireAlarm = new FireAlarmApp(hubspot);
  hubspot.fireAlarm.start();
}